<template>
  <div id="app">
    <!-- 需要缓存的页面 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!-- 不需要缓存的页面 -->
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
import handleWxRedirect from "./handler/wx.sdk.handler/wx.redirect.handler";

export default {
  name: "app",
  data() {
    return {};
  },
  mounted() {},
  created() {
    // 微信 redirect 后的处理
    handleWxRedirect();
  },
  methods: {},
};
</script>

<style lang="less">
img {
  pointer-events: none;
}
body {
  margin: 0;
  padding: 0;
  font-weight: 400;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-family: "宋体", "SourceHanSansCN-ExtraLight", "Helvetica Neue", Helvetica,
    "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", "PingFang SC", Arial,
    sans-serif;
}
</style>
